import { ScannerHostIdentificationScanningIntensity } from '@rtkwlf/rendall';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import type { ScannerDetailsForm } from '../../scanners-config/components/types';

export const useScannerDetailsValidationSchema = () => {
  const { t } = useTranslation();

  return Yup.object()
    .shape({
      deviceType: Yup.string().required(),
      model: Yup.string().required(),
      name: Yup.string()
        .trim()
        .required(t('telemetryScannerConfig:validationMessage.emptyField')),
      uuid: Yup.string(),
      version: Yup.string(),
      bruteScan: Yup.boolean(),
      cgiScan: Yup.boolean(),
      hostIden: Yup.boolean(),
      pingOnly: Yup.boolean(),
      vulnScan: Yup.boolean(),
      hostIdentificationScanIntensity:
        Yup.mixed<ScannerHostIdentificationScanningIntensity>().oneOf(
          Object.values(ScannerHostIdentificationScanningIntensity),
        ),
      hostIdentificationScanPeriod: Yup.string(),
      maxConcurrentVulnerabilityScans: Yup.string(),
    })
    .required() as Yup.ObjectSchema<ScannerDetailsForm>;
};
